
<template>
    
        <mars-view class="menu-wrapper l-span-right"><template v-if="menu.length < 2"><mars-view v-for="(item, i) in menu" :key="i" class="menu-icon c-gap-left" @click.native="onTapItem(item)"><c-icon :name="item.icon" font-size="20px"></c-icon></mars-view></template><template v-else><c-icon name="menu" font-size="20px" @click.native="showMenu"></c-icon><mars-view v-show="menuShow" class="action-menus action-menus-right"><mars-view v-for="(item, i) in menu" :key="i" class="action-item action-item-right" @click.native="tapFn(item)"><c-icon :name="item.icon" class="head-menu-icon" font-size="17px"></c-icon><mars-text class="tool-text c-gap-left c-font-normal c-color-link">{{ item.txt }}</mars-text></mars-view></mars-view></template></mars-view>
    
</template>

<script>
import Icon from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Icon/Icon.vue";
import Dialog from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Dialog/Dialog.vue";
import { act } from '../../static/utils/navigate';
export default {
  mounted() {
    document.addEventListener('click', this.hideMenu);
    document.getElementsByClassName('swan-app-navigation-bar')[0].addEventListener('click', this.hideMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMenu);
    document.getElementsByClassName('swan-app-navigation-bar')[0].removeEventListener('click', this.hideMenu);
  },
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      }
    }
    // leaveText: {   // 退出页面前挽留文案
    //     type: String,
    //     default: ''
    // },
    // leaveBtn: {     // 退出页面前挽留弹窗按钮
    //     type: Array,
    //     default() {
    //         return [];
    //     }
    // }
  },

  components: {
    'c-icon': Icon
  },
  data() {
    return {
      menuShow: false,
      isPerventLeave: false,
      isShowLeave: false,
      leaveCb: null
    };
  },
  // watch: {
  //     leaveText(v) {
  //         this.isPerventLeave = !!v;
  //     }
  // },
  methods: {
    showMenu(e) {
      this.menuShow = !this.menuShow;
      e.stopPropagation();
    },
    hideMenu() {
      this.menuShow = false;
    },
    tapFn({
      target,
      type
    }) {
      // this.go(() => {
      //     navigate({
      //         url: item.info.msUrl || item.info.url
      //     });
      // });
      act({
        target,
        type
      });
    }
    // onClosePrevent(info) {
    //     this.isShowLeave = false;
    //     // 确认退出
    //     if (info.btn.event === 'confirm') {
    //         if (typeof this.leaveCb === 'function') {
    //             let timeid = setTimeout(() => {
    //                 this.leaveCb();
    //                 clearTimeout(timeid);
    //             }, 300);
    //         }
    //     }
    // },
    // go(cb) {
    //     if (this.isPerventLeave) {
    //         this.isShowLeave = true;
    //         this.leaveCb = cb;
    //     }
    //     else {
    //         if (typeof cb === 'function') {
    //             cb();
    //         }
    //     }
    // }
  }
};
</script>

<style scoped>


.menu-wrapper {
    min-width: 40px;
    height: 40px;
    padding-right: 11px;
    text-align: right;
}
.menu-icon {
    display: inline-block;
}

.action-menus {
    position: fixed;
    z-index: 921;
    top: 41px;
    right: 17px;
    overflow: auto;
    width: auto;
    text-align: left;
    color: #333;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0,0,0,.21);
}
.head-menu-icon {
    display: inline-block;
    width: 17px;
    line-height: 46px;
}
.tool-text {
    display: inline-block;
    width: auto;
    height: 45px;
    line-height: 45px;
    vertical-align: top;
}
.action-item {
    padding: 0 18px 0 17px;
    border-right: 1px solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    font-size: 16px;
}


</style>
